import { IconeMicrofone } from '../componentes/icones';

/**
 * O botão grande da Prosa: toque para falar, toque para mandar.
 *
 * Toque-toque, e não segurar: é o que o `BotaoDeDitado` já faz, não briga com
 * a rolagem nem com o bloqueio de tela, e deixa falar um minuto sem manter o
 * polegar preso na tela.
 *
 * Só desenho — quem grava é `usarDitadoAoVivo`, em `audio/`. A separação não é
 * cosmética: `prosa/arquitetura.spec.ts` recusa fiação de socket aqui, porque é
 * assim que o replay não nasce uma segunda vez.
 */
export function Microfone({
  gravando,
  bloqueado,
  aoTocar,
}: {
  gravando: boolean;
  /** Motivo para não poder falar agora; vazio quer dizer que pode. */
  bloqueado?: string;
  aoTocar: () => void;
}): React.JSX.Element {
  return (
    <button
      type="button"
      onClick={aoTocar}
      disabled={Boolean(bloqueado)}
      data-testid="prosa-microfone"
      aria-pressed={gravando}
      aria-label={gravando ? 'Parar e mandar' : 'Falar'}
      title={bloqueado ?? (gravando ? 'Parar e mandar' : 'Falar')}
      className={
        'flex h-16 w-16 items-center justify-center rounded-full text-white transition ' +
        'disabled:cursor-not-allowed disabled:opacity-40 ' +
        (gravando
          ? 'bg-red-600 shadow-[0_0_30px_-6px_rgba(220,38,38,0.9)]'
          : 'bg-violet-600 hover:bg-violet-500')
      }
    >
      <IconeMicrofone tamanho={26} />
    </button>
  );
}
